jQuery(function(){
    var $html = jQuery('html');
    var $search = jQuery('.site-nav__sub-menu--search');

    var $account_trigger = jQuery('.mobile-nav__account-trigger');
    var $product_trigger = jQuery('.mobile-nav__product-trigger');
    var account_sub_menu_open = false;

    var showSearch = function () {
        search_open = true;
        closeItUp();
        $search.fadeIn('fast');
        jQuery('.site-nav__search-icon').addClass('site-nav__search-icon--hidden');
        jQuery('.mobile-nav__search-icon').addClass('mobile-nav__search-icon--hidden');
        jQuery('.site-nav__close-icon').removeClass('site-nav__close-icon--hidden');
        jQuery('.mobile-nav__close-icon').removeClass('mobile-nav__close-icon--hidden');
        jQuery('.site-nav__search-field').focus();
        jQuery('.mobile-nav__menu-link').text('Menu');
        jQuery('body').removeClass('noscroll');
    };

    var hideSearch = function () {
        search_open = false;
        $search.fadeOut('fast');
        jQuery('.site-nav__search-icon').removeClass('site-nav__search-icon--hidden');
        jQuery('.mobile-nav__search-icon').removeClass('mobile-nav__search-icon--hidden');
        jQuery('.site-nav__close-icon').addClass('site-nav__close-icon--hidden');
        jQuery('.mobile-nav__close-icon').addClass('mobile-nav__close-icon--hidden');
        jQuery('.site-nav__search-field').val("");

    };

    var close_open_secondary_menus = function () {
        // close the menu
        jQuery('.mobile-nav__secondary-sub-items--open').removeClass('mobile-nav__secondary-sub-items--open');
        // un-rotate the plus
        jQuery('.mobile-nav__item-link-plus--rotate').removeClass('mobile-nav__item-link-plus--rotate');
    };

    var reset_panels = function(clicked) {
        var target = clicked[0].hash;
        var $old_panel = jQuery('.mobile-nav__menu-panel--active');
        var $new_panel = jQuery(target);

        // check if there are any open sub_menus and reset them
        var $sub_menus = $old_panel.find('.mobile-nav__sub-items--slide-in');
        $sub_menus.removeClass('mobile-nav__sub-items--slide-in');

        close_open_secondary_menus();

        // Out with the old, in with the new
        $old_panel.removeClass('mobile-nav__menu-panel--active mobile-nav__menu-panel--account--slidein');
        $new_panel.addClass('mobile-nav__menu-panel--active');
    };



    jQuery('#nav-menu').on('click', function(e) {
        e.preventDefault();
        var $this = jQuery(this);

        if (jQuery('.screen').hasClass('screen--open')) {
            jQuery('.screen').removeClass('screen--open');
            jQuery('.screen').addClass('screen--closed');
            jQuery('body').removeClass('noscroll');
            $this.text('Menu');

            jQuery('.mobile-header__menu').removeClass('mobile-header__menu--open');

        }
        else if (jQuery('.screen').hasClass('screen--closed')) {
            jQuery('.screen').removeClass('screen--closed');
            jQuery('.screen').addClass('screen--open');
            $this.text('Close');
            hideSearch();

            // Reset sub-mobile menus
            var $subMenus = jQuery('.mobile-nav__sub-items');
            $subMenus.removeClass('mobile-nav__sub-items--slide-in');

            // reset account menu
            var $accountHeader = jQuery('.mobile-nav__account-header');
            $accountHeader.removeClass('mobile-nav__menu-header--slidein');
            jQuery('#nav-account').removeClass('mobile-nav__menu-panel--account--slidein mobile-nav__menu-panel--active');
            jQuery('#nav-products').addClass('mobile-nav__menu-panel--active');

            // reset secondary sub navs
            close_open_secondary_menus();

            // Scroll to top of menu
            jQuery('.mobile-header__menu-container').scrollTop(0);

            jQuery('.mobile-header__menu').fadeIn().addClass('mobile-header__menu--open');

        }
        else {
            jQuery('.screen').addClass('screen--open');

            $this.text('Close');
            hideSearch();
        }

        jQuery('.mobile-header__menu-container').height(jQuery(window).height() - 104);

        jQuery('.screen--open').height(jQuery(document).height() - jQuery('.mobile-header').height());

        jQuery('.mobile-header__menu').one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
            jQuery('.mobile-header__menu-container').toggleClass('mobile-header__menu-container--safari-scroll-bug');

            if (jQuery(this).hasClass('mobile-header__menu--open')) {
                jQuery('body').addClass('noscroll');
            } else {
                jQuery(this).fadeOut(50);
            }

        });

    });

    jQuery(window).resize(function(){
        jQuery('.mobile-header__menu-container').height('calc(100vh - 100px)');
    });

    jQuery('.mobile-nav__item').one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function(event) {
        jQuery('.screen--open').height(jQuery(document).height() - jQuery('.mobile-header').height());
    });


    // OPEN GREY ACCORDION MENUS
    jQuery('.mobile-nav__item-link--trigger').on('click', function(e) {
        e.preventDefault();

        $this = jQuery(this);
        var $parent = $this.parent();
        var index = $parent.index();

        //console.log(index);
        //console.log('going');

        var $sub_menu = $this.next('.mobile-nav__secondary-sub-items');
        var $plus = $this.find('.mobile-nav__item-link-plus');

        // Corresponding item in other menu
        var $menu_item = jQuery('.mobile-nav__items--dark-grey .mobile-nav__item').eq(index);
        var $menu = $menu_item.find('.mobile-nav__secondary-sub-items');
        var $plus_sign = $menu_item.find('.mobile-nav__item-link-plus');

        if ($sub_menu.hasClass('mobile-nav__secondary-sub-items--open')) {

            $sub_menu.removeClass('mobile-nav__secondary-sub-items--open');
            $plus.removeClass('mobile-nav__item-link-plus--rotate');

        } else {

            $sub_menu.addClass('mobile-nav__secondary-sub-items--open');
            $plus.addClass('mobile-nav__item-link-plus--rotate');

            var offset = $sub_menu.offset().top;

            var $list_item = jQuery('.mobile-nav__items--dark-grey .mobile-nav__item').eq(index);

            $menu.addClass('mobile-nav__secondary-sub-items--open');
            $plus_sign.find('.mobile-nav__item-link-plus').addClass('mobile-nav__item-link-plus--rotate');

            jQuery('.mobile-nav__secondary-sub-items--open').one("webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend", function (event) {

                var $this = jQuery(this);

                if ($this.hasClass('mobile-nav__secondary-sub-items--open')) {

                    jQuery('.mobile-header__menu-container').animate({
                        scrollTop: jQuery('.mobile-nav__menu-panel').height()
                    }, 700);

                }


            });
        }

    });

    // OPEN MY ACCOUNT MENU
    $account_trigger.on('click', function(e){
        e.preventDefault();

        $this = jQuery(this);

        $product_trigger.parent('.mobile-nav__menu-header').addClass('mobile-nav__menu-header--slidein');
        jQuery('#nav-account').addClass('mobile-nav__menu-panel--account--slidein');

        reset_panels($this);

    });

    jQuery('.mobile-nav__header-link--previous').on('click', function (e) {
        e.preventDefault();

        $this = jQuery(this);

        if (account_sub_menu_open) {

            jQuery('.mobile-nav__sub-items--slide-in').removeClass('mobile-nav__sub-items--slide-in');
            jQuery('.mobile-nav__menus-container').css({ height: 'auto' });
            account_sub_menu_open = false;
            return true;
        }

        $this.parent('.mobile-nav__menu-header').removeClass('mobile-nav__menu-header--slidein');
        jQuery('.mobile-nav__menus-container').css({ height: 'auto' });

        reset_panels($this);

    });

    jQuery('.mobile-nav__item-link').on('click', function(e){
        var $this = jQuery(this);

        if($this.hasClass('mobile-nav__item-link--nosub')) {
            return true;
        }

        if ($this.hasClass('mobile-nav__item-link--account')) {
            account_sub_menu_open = true;
        }

        var $scroller = $this.parents('.mobile-header__menu-container');
        var $container = $this.parents('.mobile-nav__menus-container');
        var $parent = $this.parent('.mobile-nav__item');
        var $sub_items = $parent.children('.mobile-nav__sub-items');
        var newHeight = 'auto';

        close_open_secondary_menus();
        $sub_items.addClass('mobile-nav__sub-items--slide-in');

        newHeight = $sub_items.height() ? $sub_items.height() : 'auto';
        $container.css({height: newHeight});

        $scroller.scrollTop(0);

        return false;
    });

    jQuery('.mobile-nav__sub-nav-previous-link').on('click', function(e){
        e.preventDefault();

        var $sub_menu = jQuery(this).parents('.mobile-nav__sub-items--slide-in');
        $sub_menu.removeClass('mobile-nav__sub-items--slide-in');
    });


    jQuery('.screen').on('click', function(e){
        var $this = jQuery(this);

        if(jQuery('.mobile-header__menu').hasClass('mobile-header__menu--open') && $this.hasClass('screen--open')) {
            jQuery('.mobile-header__menu').removeClass('mobile-header__menu--open');
            $this.toggleClass('screen--open');
            jQuery('#nav-menu').text('Menu');
        }
    });

    // Handle Hover States
    var dropdown_close_timer;
    var NOT_AN_ACCIDENT = 150;
    var DROPDOWN_CLOSE_TIMEOUT = 50;
    var MAGIC = 10;
    var menu_open = false;
    var moving_timer;
    var search_open = false;

    var closeItUp = function() {
        menu_open = false;
        $html.removeClass('_show-dropdown');
        $html.removeClass('_show-sub-menu');
        $html.removeClass('_prepare-sub-menu');
        $html.attr('data-currentsection', '');

        // Close mobile menu if open
        jQuery('.mobile-header__menu').removeClass('mobile-header__menu--open');
        jQuery('.screen').removeClass('screen--open');
    };

    var showTheMenu = function(key) {
        hideSearch();
        $html.addClass('_show-dropdown');
        $html.attr('data-currentsection', key);
        $html.addClass('_prepare-sub-menu');

        setTimeout(function() {
            $html.addClass('_show-sub-menu');
            menu_open = true;

        }, MAGIC);
    };

    // Only fire below code if 1. Sub_menu is not show or 2. Sub_menu is shown but mouse is not moving.
    jQuery('.site-nav__menu-item-link').on('mouseenter click', function(e) {

        if(e.type == 'click' && 'ontouchstart' in window) {
            e.preventDefault();
        }

        var $el = jQuery(this);
        var key = $el.data('key');

        clearTimeout(dropdown_close_timer);
        clearTimeout(moving_timer);

        moving_timer = setTimeout(function () {

            if (!menu_open) {

                if (!$el.hasClass('site-nav__menu-item-link--no-sub')) {
                    showTheMenu(key);
                }

            } else {

                if (!$el.hasClass('site-nav__menu-item-link--no-sub')) {
                    showTheMenu(key);
                } else {
                    dropdown_close_timer = setTimeout(closeItUp, DROPDOWN_CLOSE_TIMEOUT);
                }

            }

        }, NOT_AN_ACCIDENT);

    });

    jQuery('.site-nav__menu-item-link').on('mouseleave touchend', function() {
        var $el = jQuery(this);
        var key = $el.data('key');
        clearTimeout(moving_timer);
    });

    jQuery('.site-nav__content').on('mouseleave touchend', function() {
        dropdown_close_timer = setTimeout(closeItUp, DROPDOWN_CLOSE_TIMEOUT);
    });

    jQuery('.site-nav__sub-menu').on('mouseenter touchend', function() {
        clearTimeout(dropdown_close_timer);
        clearTimeout(moving_timer);
    });

    jQuery('.site-nav__sub-menu').on('mouseleave touchend', function() {
        dropdown_close_timer = setTimeout(closeItUp, DROPDOWN_CLOSE_TIMEOUT);
    });

    // SEARCH THINGS
    jQuery('.site-nav__menu-item-link--search, .mobile-nav__search-link').on('click', function() {

        if (search_open) {
            hideSearch();
        } else {
            showSearch();
        }
    });

    // KEYBOARD NAVIGATION
    var keycodes = {
        space: 32,
        enter: 13,
        tab: 9,
        down: 40,
        left: 37,
        right: 39,
        up: 38,
        escape: 27
    };

    function get_current_menu_links(key) {

        if (!key) {
            key = jQuery('html').data('currentsection');
        }
        var current_menu = jQuery('.site-nav__sub-menu--' + key);
        var links = current_menu.find('.site-nav__sub-link');

        return links;
    }

    var current_menu_links;
    var parent_item;

    jQuery('.site-nav__menu-item-link:not(.site-nav__menu-item-link--no-sub)').on('focus', function() {

        jQuery(this).on('keydown', function(event) {

            var pressed = event.keyCode;

            if (!menu_open && pressed === keycodes.tab) {
                // go to next link
                return true;
            } else {
                event.preventDefault();

                if (menu_open) {

                    if (pressed === keycodes.escape) {
                        closeItUp();
                        hideSearch();
                    }

                    if (pressed === keycodes.tab || pressed === keycodes.down) {
                        current_menu_links[0].focus();
                    }

                } else { // Menu is NOT open

                    if (pressed === keycodes.space || pressed === keycodes.down) {
                        var $el = jQuery(this);
                        var key = $el.data('key');

                        showTheMenu(key);
                        menu_open = true; // set to open immediately
                        current_menu_links = get_current_menu_links(key);
                        parent_item = jQuery('.site-nav__menu-item-link[data-key="' + key + '"]');
                    }
                }
            }

        });
    });

    jQuery('.site-nav__sub-link').on('focus', function(event) {

        jQuery(this).on('keydown', function (event) {

            var pressed = event.keyCode;
            var link_index = current_menu_links.index(this);

            if (pressed === keycodes.up || pressed === keycodes.down || pressed === keycodes.tab || pressed === keycodes.escape) {
                event.preventDefault();

                // if link is first
                if (pressed === keycodes.up || (pressed === keycodes.tab && event.shiftKey)) {

                    if (link_index === 0) {

                        parent_item.focus();
                        closeItUp();

                    } else {
                        current_menu_links[link_index - 1].focus();
                    }

                }

                // if link is last
                if (pressed === keycodes.down || (pressed === keycodes.tab && !event.shiftKey)) {

                    if (link_index === current_menu_links.length - 1) {

                        parent_item.focus();
                        closeItUp();

                    } else {
                        current_menu_links[link_index + 1].focus();
                    }

                }

                if (pressed === keycodes.escape ) {
                    parent_item.focus();
                    closeItUp();
                    hideSearch();
                }

            }

        });

    });

    jQuery('.site-nav__menu-item-link--search, .site-nav__search-field').on('focus', function () {
        jQuery(this).on('keydown', function (event) {

            var pressed = event.keyCode;

            if (search_open && (pressed === keycodes.escape)) {
                event.preventDefault();

                hideSearch();
            }
        });

    });

    jQuery('.mobile-nav__item-link--trigger').on('focus', function() {
        jQuery(this).on('keydown', function(event) {

            jQuery(this).trigger('click');

        });
    });


    // * NCC-606 | Close menu on rotation
    function doOnOrientationChange() {
      if (jQuery('.screen').hasClass('screen--open')) {
        jQuery("#nav-menu").trigger("click");
      }
    }
    window.addEventListener('orientationchange', doOnOrientationChange);

    // * NCC-1398 | Sticky Nav
    // // ? Check scroll distance
    // /* ? (c) 2019 Chris Ferdinandi, MIT License, https://gomakethings.com */
    // var scrollDistance = function (callback, refresh) {

    //   // Make sure a valid callback was provided
    //   if (!callback || typeof callback !== 'function') return;
    //   var isScrolling, start, end, distance;

    //   window.addEventListener('scroll', function (event) {
    //     // Set starting position
    //     if (!start) {
    //       start = window.pageYOffset;
    //     }

    //     // Clear our timeout throughout the scroll
    //     window.clearTimeout(isScrolling);

    //     // Set a timeout to run after scrolling ends
    //     isScrolling = setTimeout(function () {
    //       // Calculate distance
    //       end = window.pageYOffset;
    //       distance = end - start;

    //       // Run the callback
    //       callback(distance, start, end);

    //       // Reset calculations
    //       start = null;
    //       end = null;
    //       distance = null;

    //     }, refresh || 66);

    //   }, false);

    // };
    // function scrollDisplayMenu() {
    //   var lastScroll = 0;
    //   window.onscroll = function () {
    //     var currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value
    //     var $scroll_elems = jQuery(".mobile-header, .mobile-menu, .site-header, .site-nav-container");

    //     scrollDistance(function (distance) {

    //       var currentDistance = parseInt(Math.abs(distance), 10);

    //       // ? check scroll distance
    //       if(currentDistance>100) {

    //         if (currentScroll > 0 && lastScroll <= currentScroll) {
    //           // ? scrolling down
    //           lastScroll = currentScroll;

    //           if (currentScroll > 150) {
    //             $scroll_elems.addClass("NCC-1398--scrolldown");
    //           }

    //         } else {
    //           // ? scrolling up
    //           lastScroll = currentScroll;

    //           if (currentScroll < 180) {
    //             $scroll_elems.addClass("NCC-1398--scrolldown");
    //           }

    //           if (currentScroll > 150) {
    //             $scroll_elems.addClass("NCC-1398--scrollup");
    //             $scroll_elems.removeClass("NCC-1398--scrolldown");
    //           }
    //         }
    //       }

    //     });

    //   };

    // }

    // var $scroll_container = jQuery(".scroll-container");
    // var isIE11 = /Trident.*rv[ :]*11\./.test(navigator.userAgent);
    // $scroll_container.addClass("NCC-1398--disable-overflow");

    // // ? On Mobile menu click - scroll to top, adjust overflow for sticky nav
    // jQuery(".mobile-nav__menu-link").bind('click tap', function () {
    //   window.scrollTo(0,0);
    //   $scroll_container.toggleClass("NCC-1398--disable-overflow");
    // });

    // if (!isIE11) { scrollDisplayMenu(); }

});
